"use client";
import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

let apiAbortController: AbortController | null = null;
const getCustomModule = async (moduleId: string) => {
  // Cancel previous request if it exists
  if (apiAbortController) {
    apiAbortController.abort();
  }

  // Create a new AbortController for the current request
  apiAbortController = new AbortController();
  const url = `${config.baseURL}/api/custom-modules/${moduleId}`;
  try {
    console.log({ url: url.toString() });

    const response = await AUTH_GET(url.toString(), {
      revalidate: 0,
      tags: ["custom-modules", moduleId],
      signal: apiAbortController?.signal,
    });
    apiAbortController = null; // Clear the controller after successful request

    return response;
  } catch (error: any) {
    const errorPayload = {
      error,
      url,
      d: `${config.baseURL}/api/custom-modules/${moduleId}`,
    };
    console.log({ errorPayload });
    if (error.name === "AbortError") {
      // Handle fetch cancellation
      console.log("Fetch request canceled");
    } else {
      // Handle other errors
      throw errorPayload;
    }
  }
};

export default getCustomModule;
